import React, { useEffect, useState } from "react";
import HeartIcon from "../../../assets/icons/ABHA-icons/heart-icon";
import TickIcon2 from "../../../assets/icons/ABHA-icons/tick2-icon";
import TickIcon3 from "../../../assets/icons/ABHA-icons/tick3-icon";
import GovIcon from "../../../assets/icons/ABHA-icons/gov-icon";
import InputField from "../../forms/input-field";
import { Form, Formik } from "formik";
import errorToast from "../../helper-components/error-toast";
import AddButton from "../../buttons/button";
import * as Yup from "yup";
import { RefreshCw } from "lucide-react";
import { url } from "../../../redux/config";
import { accessTokenAction } from "../../../redux/actions/admin-customer-action";
import axios from "axios";
import successToast from "../../helper-components/success-toast";
import { useDispatch } from "react-redux";

function ABHA({
  adhaarAccessToken,
  adhaarX_Token,
  setStatus,
  setTxnId,
  closeModal,
  setAdhaarAccessToken,
  adhaarSuccessData,
}) {
  const [loading, setLoading] = useState(false);
  const [showABHADetails, setShowABHADetails] = useState(false);
  const [abhaCardImage, setAbhaCardImage] = useState(null);

  const [mathQuestion, setMathQuestion] = useState({
    question: "",
    answer: "",
  });
  const [verificationError, setVerificationError] = useState("");

  const dispatch = useDispatch();

  // Get ABHA card image immediately on component mount
  useEffect(() => {
    downloadABHA();
    getABHACardImage();
  }, []);

  const getABHACardImage = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${url}/abha-integration/abha-download`,
        {
          x_token: adhaarX_Token,
          accessToken: adhaarAccessToken,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob", // Handle binary data for ABHA card image
        }
      );

      // Create blob URL for displaying the image
      const blob = new Blob([response.data], { type: "image/png" });
      const imageUrl = URL.createObjectURL(blob);

      setAbhaCardImage(imageUrl);
      setShowABHADetails(true);
      setLoading(false);
    } catch (error) {
      errorToast(error.response?.data?.message || "Failed to fetch ABHA card");
      console.error(
        "Error fetching ABHA card:",
        error.response?.data || error.message
      );
      setLoading(false);
    }
  };

  const downloadABHA = async () => {
    try {
      setLoading(true);
      const response = await axios.post(
        `${url}/abha-integration/abha-download`,
        {
          x_token: adhaarX_Token,
          accessToken: adhaarAccessToken,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          responseType: "blob", // Handle binary data for ABHA card download
        }
      );

      console.log("Response:", response);

      // Create blob and download immediately
      const blob = new Blob([response.data], { type: "image/png" }); // or 'image/png' depending on your API
      const imageUrl = URL.createObjectURL(blob);

      // Create download link and trigger download
      const link = document.createElement("a");
      link.href = imageUrl;
      link.download = `ABHA-Card-${
        adhaarSuccessData?.ABHANumber || Date.now()
      }.png`; // or .png
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(imageUrl);

      successToast("ABHA Card Downloaded Successfully");
      setLoading(false);

      return response.data;
    } catch (error) {
      errorToast(error.response?.data || error.message);
      console.error(
        "Error downloading ABHA:",
        error.response?.data || error.message
      );
      setLoading(false);
    }
  };
  //   const downloadABHA = async () => {
  //     try {
  //       setLoading(true);
  //       const response = await axios.post(
  //         `${url}/abha-integration/abha-download`,
  //         {
  //           x_token: adhaarX_Token,
  //           accessToken: adhaarAccessToken,
  //         },
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //           responseType: "blob", // Handle binary data for ABHA card download
  //         }
  //       );

  //       console.log("Response:", response);

  //       // Create blob and download immediately
  //       const blob = new Blob([response.data], { type: "image/png" }); // or 'image/png' depending on your API
  //       const imageUrl = URL.createObjectURL(blob);

  //       // Create download link and trigger download
  //       const link = document.createElement("a");
  //       link.href = imageUrl;
  //       link.download = `ABHA-Card-${
  //         adhaarSuccessData?.ABHANumber || Date.now()
  //       }.png`; // or .png
  //       document.body.appendChild(link);
  //       link.click();
  //       document.body.removeChild(link);
  //       URL.revokeObjectURL(imageUrl);

  //       successToast("ABHA Card Downloaded Successfully");
  //       setLoading(false);

  //       return response.data;
  //     } catch (error) {
  //       errorToast(error.response?.data || error.message);
  //       console.error(
  //         "Error downloading ABHA:",
  //         error.response?.data || error.message
  //       );
  //       setLoading(false);
  //     }
  //   };

  const getABHA = async (data, mobile) => {
    try {
      const response = await axios.post(
        `${url}/abha-integration/find-abha-using-mobile`,
        {
          accessToken: data,
          mobile: JSON.stringify(mobile),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      successToast("OTP is sent");

      console.log("Response:", response);
      console.log("txnid", response?.data?.data?.abdmResponse?.txnId);
      setAdhaarAccessToken(data);
      setTxnId(response?.data?.data?.abdmResponse?.txnId);
      setStatus("otp");
      setLoading(false);

      return response.data;
    } catch (error) {
      console.log("hhhhhhhhhhhhhhhh", error?.response?.data);
      errorToast(error?.response?.data?.message);
      console.error(
        "Error sending OTP:",
        error.response?.data || error.message
      );
      setLoading(false);
    }
  };

  const getAccessToken = async () => {
    try {
      const response = await axios.post(
        `${url}/abha-integration/generate-session-token`,
        {
          clientId: "SBXID_009917",
          clientSecret: "68bd8f02-4c70-405f-850e-9774da34917d",
          grantType: "client_credentials",
        },
        { headers: { "Content-Type": "application/json" } }
      );

      console.log("1111111111111111111111111", response);
      return response?.data?.data?.sessionToken?.accessToken;
    } catch (error) {
      errorToast(error?.response?.data?.message || "Auth failed");
      throw error;
    }
  };

  const onsave = async (values) => {
    setLoading(true);
    try {
      const token = await getAccessToken();
      await getABHA(token, values.mobile);
    } catch (err) {
      console.error("Onsave error:", err);
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col h-full">
      {/* Display ABHA Card Image */}
      {showABHADetails && abhaCardImage && (
        <div className="flex-1 p-6">
          {/* ABHA Card Image */}
          <div className="flex justify-center mb-6">
            <div className="bg-white rounded-lg shadow-lg p-4 max-w-lg">
              <img
                src={abhaCardImage}
                alt="ABHA Card"
                className="w-full h-auto rounded-lg"
                style={{ maxHeight: "400px", objectFit: "contain" }}
              />
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex gap-4 justify-center">
            <button
              onClick={downloadABHA}
              disabled={loading}
              className="bg-blue-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
            >
              {loading ? "Downloading..." : "Download ABHA Card"}
            </button>
            <button
              onClick={() => {
                // Add functionality to use this ABHA
                successToast("ABHA details saved successfully");
                closeModal();
              }}
              className="bg-green-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-green-700 transition-colors"
            >
              Use This ABHA
            </button>
          </div>
        </div>
      )}

      {/* Loading State */}
      {loading && (
        <div className="flex-1 flex items-center justify-center">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
            <p className="text-gray-600">Processing...</p>
          </div>
        </div>
      )}

      {/* No ABHA Card */}
      {!showABHADetails && !loading && (
        <div className="flex-1 flex items-center justify-center">
          <div className="text-center">
            <p className="text-gray-600 mb-4">No ABHA card found</p>
            <button
              onClick={() => setStatus("Method Selection")}
              className="bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors"
            >
              Try Again
            </button>
          </div>
        </div>
      )}

      {/* Bottom Action Buttons */}
      <div className="flex justify-end mt-auto mb-6 mr-6">
        <button
          onClick={() => {
            // Clean up blob URL to prevent memory leaks
            if (abhaCardImage) {
              URL.revokeObjectURL(abhaCardImage);
            }
            closeModal();
          }}
          className="flex items-center px-3 py-2 whitespace-nowrap rounded-md gap-[8px] bg-red-500 cursor-pointer text-white text-[length:var(--draft-button-fs)] font-[var(--draft-button-fw)] hover:bg-red-600 transition-colors"
          type="button"
        >
          Cancel
        </button>
      </div>
      <div className="flex flex-row gap-3 justify-end  sticky bg-white py-4 mt-auto ">
        <AddButton
          prefixIcon={false}
          // ref={submitRef}
          onclkFn={() => closeModal()}
          text={<span>Cancel</span>}
          className="
          flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
           cursor-pointer
          text-[var(--primary-button-bg-color)]
          border border-[var(--primary-button-bg-color)]
          text-[length:var(--primary-button-create-fs)]
          font-[var(--primary-button-font-weight)]
          "
          type="button"
        />
      </div>
    </div>
  );
}
// function ABHA({
//   adhaarAccessToken,
//   adhaarX_Token,
//   setStatus,
//   setTxnId,
//   closeModal,
//   setAdhaarAccessToken,
//   adhaarSuccessData,
// }) {
//   const [loading, setLoading] = useState(false);

//   const [mathQuestion, setMathQuestion] = useState({
//     question: "",
//     answer: "",
//   });
//   const [verificationError, setVerificationError] = useState("");

//   const dispatch = useDispatch();

//   useEffect(() => {
//     downloadABHA();
//   }, []);

//   const onTokenFail = (data) => {
//     setLoading(false);
//     errorToast(data.message);
//   };

//   const downloadABHA = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.post(
//         `${url}/abha-integration/abha-download`,
//         {
//           x_token: adhaarX_Token,
//           accessToken: adhaarAccessToken,
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//           responseType: "blob", // Handle binary data for ABHA card download
//         }
//       );

//       console.log("Response:", response);

//       // Create blob and download immediately
//       const blob = new Blob([response.data], { type: "image/png" }); // or 'image/png' depending on your API
//       const imageUrl = URL.createObjectURL(blob);

//       // Create download link and trigger download
//       const link = document.createElement("a");
//       link.href = imageUrl;
//       link.download = `ABHA-Card-${
//         adhaarSuccessData?.ABHANumber || Date.now()
//       }.png`; // or .png
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//       URL.revokeObjectURL(imageUrl);

//       successToast("ABHA Card Downloaded Successfully");
//       setLoading(false);

//       return response.data;
//     } catch (error) {
//       errorToast(error.response?.data || error.message);
//       console.error(
//         "Error downloading ABHA:",
//         error.response?.data || error.message
//       );
//       setLoading(false);
//     }
//   };
//   const getABHA = async (data, mobile) => {
//     try {
//       const response = await axios.post(
//         `${url}/abha-integration/find-abha-using-mobile`,
//         {
//           accessToken: data,
//           mobile: JSON.stringify(mobile),
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );
//       successToast("OTP is sent");

//       console.log("Response:", response);
//       console.log("txnid", response?.data?.data?.abdmResponse?.txnId);
//       setAdhaarAccessToken(data);
//       setTxnId(response?.data?.data?.abdmResponse?.txnId);
//       // setmessage(response?.data?.data?.abdmResponse?.message);
//       console.log("--------------------------------", response);
//       // setStatus("OTP Verification");
//       // setPosition(2);
//       setStatus("otp");
//       setLoading(false);
//       //   setPopUp(true);

//       return response.data;
//     } catch (error) {
//       console.log("hhhhhhhhhhhhhhhh", error?.response?.data);
//       errorToast(error?.response?.data?.message);
//       console.error(
//         "Error sending OTP:",
//         error.response?.data || error.message
//       );
//       setLoading(false);
//       // throw error;
//     }
//   };
//   const getAccessToken = async () => {
//     try {
//       const response = await axios.post(
//         `${url}/abha-integration/generate-session-token`,
//         {
//           clientId: "SBXID_009917",
//           clientSecret: "68bd8f02-4c70-405f-850e-9774da34917d",
//           grantType: "client_credentials",
//         },
//         { headers: { "Content-Type": "application/json" } }
//       );

//       console.log("1111111111111111111111111", response);
//       return response?.data?.data?.sessionToken?.accessToken;
//     } catch (error) {
//       errorToast(error?.response?.data?.message || "Auth failed");
//       // errorToast(error);
//       throw error;
//     }
//   };
//   const onsave = async (values) => {
//     setLoading(true);
//     try {
//       const token = await getAccessToken();
//       await getABHA(token, values.mobile);
//     } catch (err) {
//       console.error("Onsave error:", err);
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="flex flex-col h-full">
//       {/* {display ABHA PIC} */}

//       <div className="flex  justify-end  mt-auto mb-6 mr-6">
//         <AddButton
//           prefixIcon={false}
//           text={"Cancel"}
//           onclkFn={() => closeModal()}
//           className="
//     flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
//     bg-[var(--trans-stats-con-red-fg)] cursor-pointer
//     text-white
//     text-[length:var(--draft-button-fs)]
//     font-[var(--draft-button-fw)]
//     "
//           type="button"
//         />
//       </div>
//     </div>
//   );
// }
export default ABHA;
